module.exports = __webpack_public_path__ + "teqbahn-assets/media/TPR.Slidedeck_5.fd94cc91.jpg";